export class TenantGroup {
    id!: number;
    name!: string;
    image?: string;
    active!: boolean;
}